import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, {useEffect, useRef, useState} from "react";
import {v4} from "uuid";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import weapons_range from "../../_data/weapons_range";
import weapons_close from "../../_data/weapons_close";
import {Checkbox, FormControlLabel} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import {ICharWeapon} from "../../_interfaces/ICharWeapon";
import {s_char, s_char_weapons} from "../../_signals/s_char";
import {s_char_attr_str} from "../../_signals/s_char_attr";
import {useSignals} from "@preact/signals-react/runtime";
import {WeaponsCreate} from "../../_api/BEWeapons";

interface IProp {
    add: boolean,
    isOpen: (open: boolean) => void
}

function WeaponsAdd({add, isOpen}: IProp) {
    useSignals()

    const mod_15 = [...Array(16).keys()];

    const descRef = useRef<HTMLInputElement>(null);

    const [weapon, setWeapon] = useState<ICharWeapon | null>(null)

    useEffect(() => {

        if (add) {
            const addWeapon: ICharWeapon = {
                id: v4(),
                cid: s_char.value.id,
                wield: false,
                name: '',
                descr: '',
                type: '',
                attribute: '',
                dmg: 0,
                dmg_mod: 0,
                min_str: 0,
                weight: 0,
                size: 0,
                price: 0,
                avail: '',
                short_f: 0,
                short_t: 0,
                far_f: 0,
                far_t: 0
            }

            setWeapon(addWeapon)
        } else setWeapon(null)
    }, [add])

    const save = () => {
        let weapons = s_char_weapons.value;
        if (weapon && weapon?.name !== '') {
            weapon.descr = descRef.current?.value as string
            setWeapon(weapon)
            weapons.unshift(weapon);
            s_char_weapons.value = weapons;
            WeaponsCreate(weapon)
            isOpen(false)
        } else isOpen(false)
    }

    const cancel = () => {
        setWeapon(null)
        isOpen(false)
    }

    return <Dialog open={add}>
        <DialogContent>
            <FormControl sx={{m: 1, width: "100%"}}>
                <InputLabel id="close_label">Nahkampfwaffe</InputLabel>
                <Select
                    labelId="close_label"
                    value={weapon?.name && weapon?.type === 'close' ? weapon?.name : ''}
                    style={{width: "100%"}}
                    variant="standard"
                >
                    {weapons_close.map(a => <MenuItem key={v4()}
                                                      value={a.name}
                                                      onClick={() => {
                                                          setWeapon({
                                                              id: v4(),
                                                              cid: s_char.value.id,
                                                              wield: false,
                                                              name: a.name,
                                                              descr: '',
                                                              type: 'close',
                                                              attribute: a.attr,
                                                              dmg: a.dmg,
                                                              dmg_mod: 0,
                                                              min_str: a.min_str,
                                                              size: a.size,
                                                              price: a.price,
                                                              avail: a.avail,
                                                              weight: a.weight,
                                                              short_f: 0,
                                                              short_t: 0,
                                                              far_f: 0,
                                                              far_t: 0
                                                          })
                                                      }}>

                        {a.name} ({a.dmg})
                        {a.min_str > s_char_attr_str.value ?
                            <span style={{marginLeft: 'auto', fontSize: "small"}}>
                                        {'Min-Str ' + a.min_str + ' ' + (s_char_attr_str.value - a.min_str)}
                                    </span>
                            : ''}
                    </MenuItem>)}
                </Select>
            </FormControl>
            <FormControl sx={{m: 1, width: "100%"}}>
                <InputLabel id="range_label">Fernkampfwaffe</InputLabel>
                <Select
                    labelId="range_label"
                    value={weapon?.name && weapon?.type === 'range' ? weapon?.name : ''}
                    style={{width: "100%"}}
                    variant="standard"
                >
                    {weapons_range.map(a => <MenuItem key={v4()}
                                                      value={a.name}
                                                      onClick={() => {
                                                          setWeapon({
                                                              id: v4(),
                                                              cid: s_char.value.id,
                                                              wield: false,
                                                              name: a.name,
                                                              descr: '',
                                                              type: 'range',
                                                              attribute: a.attr,
                                                              dmg: a.dmg,
                                                              dmg_mod: 0,
                                                              min_str: a.min_str,
                                                              size: a.size,
                                                              price: a.price,
                                                              weight: a.weight,
                                                              avail: a.avail,
                                                              short_f: a.short_f,
                                                              short_t: a.short_t,
                                                              far_f: a.far_f,
                                                              far_t: a.far_t
                                                          })
                                                      }}>

                        {a.name} ({a.dmg})
                        {a.min_str > s_char_attr_str.value ?
                            <span style={{marginLeft: 'auto', fontSize: "small"}}>
                                    {'Min-Str ' + a.min_str + ' ' + (s_char_attr_str.value - a.min_str)}
                                </span>
                            : ''}
                    </MenuItem>)}
                </Select>
            </FormControl>

            <TextField style={{width: '100%', marginTop: 8}}
                       defaultValue={weapon?.descr}
                       label={'Beschreibung'}
                       inputRef={descRef}>
            </TextField>

            <Stack style={{width: '100%', marginTop: 8}} direction={'row'}>
                <FormControlLabel style={{marginLeft: 0}} control={
                    <Checkbox defaultChecked={weapon?.wield || false}
                              onChange={
                                  (e) => {
                                      let curr = weapon;
                                      if (curr) {
                                          curr.wield = e.target.checked;
                                          setWeapon(curr)
                                      }
                                  }
                              }/>
                } label="getragen"/>

                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="dmg_mod_label">Modifikator Schaden</InputLabel>
                    <Select defaultValue={weapon?.dmg_mod}
                            labelId="dmg_mod_label"
                            style={{width: "100%"}}
                            onChange={(e) => {
                                let curr = weapon;
                                if (curr) {
                                    curr.dmg_mod = e.target.value as number;
                                    setWeapon(curr)
                                }
                            }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
            </Stack>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => save()}><CheckIcon/></Button>
            <Button onClick={() => cancel()}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>

}

export default WeaponsAdd
